import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const SectionCard = ({ icon, title, subtitle, preview, defaultExpanded = false, children }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
      {/* Header */}
      <button
        type="button"
        onClick={() => setExpanded((prev) => !prev)}
        className="w-full flex items-center gap-3 p-4 md:px-6 md:py-4 text-left hover:bg-gray-50/60 transition-colors"
      >
        {/* Icon */}
        <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-orange-500">
          {icon}
        </span>

        {/* Title + subtitle */}
        <div className="flex-1 min-w-0">
          <span className="font-semibold text-gray-900 text-sm">{title}</span>
          {subtitle && (
            <span className="block text-xs text-gray-500 mt-0.5">{subtitle}</span>
          )}
        </div>

        {/* Preview text (hidden on mobile <sm) */}
        {preview && (
          <span className="hidden sm:block flex-shrink min-w-0 max-w-[40%] text-xs text-gray-500 truncate ml-auto mr-2">
            {preview}
          </span>
        )}

        {/* Chevron */}
        <span className="flex-shrink-0 text-gray-400">
          {expanded ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </span>
      </button>

      {/* Body */}
      {expanded && (
        <div className="border-t border-gray-100 px-4 pt-4 pb-4 md:px-6 md:pb-6">
          {children}
        </div>
      )}
    </div>
  );
};

export default SectionCard;
